import useCurrentUser from "@shared/queries/useCurrentUser";
import { useEffect, useMemo } from "react";
import { useMatchUsers } from "../queries/useMatchUsers";
import {
  type DiscoveryMatchCelebrationState,
  resolveDiscoveryCelebrationPair,
} from "./DiscoveryMatchCelebrationOverlay";
import { preloadProfilePhotosForCelebration } from "./matchCelebrationPreload";

export function useDiscoveryPageCelebration(
  currentUserId: string,
  showCelebration: boolean,
  matchData: DiscoveryMatchCelebrationState | null
) {
  const { user: viewer } = useCurrentUser();
  const shouldFetchMatchUsers = Boolean(showCelebration && matchData?.matchedUserId && !matchData.matchedUser);
  const { data: matchUsers, isLoading: matchUsersLoading } = useMatchUsers(
    currentUserId,
    shouldFetchMatchUsers ? (matchData?.matchedUserId ?? "") : ""
  );

  const celebrationPair = useMemo(
    () =>
      resolveDiscoveryCelebrationPair({
        matchData,
        showCelebration,
        matchUsers: matchUsers ?? undefined,
        matchUsersLoading,
        viewer: viewer ?? undefined,
      }),
    [matchData, showCelebration, matchUsers, matchUsersLoading, viewer]
  );

  useEffect(() => {
    if (!showCelebration || !celebrationPair) {
      return;
    }
    preloadProfilePhotosForCelebration(celebrationPair.user1.photo_url, celebrationPair.user2.photo_url);
  }, [showCelebration, celebrationPair]);

  return { celebrationPair, matchUsersLoading };
}
